export default __webpack_public_path__ + "static/media/bottom.a1c86efb.png";